import QzTrayClientService from "../../../services/qztray/QzTrayClientService";
import { AppDispatch } from "../../../store/store";
import {
  setClientConfig,
  setLoading,
  setError,
} from "../../../store/slices/qztray/qzTrayClientSlice";

export const fetchClientConfigLogic = async (
  dispatch: AppDispatch,
  handle: (err: any) => void,
  showAlert: (type: string, title: string, msg: string) => void
) => {
  try {
    // console.log("⚙️ Solicitando configuración QZ Tray al backend...");
    dispatch(setLoading(true));

    const response = await QzTrayClientService.getClientConfig();
    const { statusCode, data, message } = response;

    if (statusCode === 200 && data) {
      dispatch(setClientConfig(data));
      // console.log("⚙️ Configuración QZ Tray cargada:", data);
      showAlert("success", "Configuración QZ Tray", message || "Configuración cargada correctamente.");
    } else {
      throw new Error("No se encontró configuración válida en el backend.");
    }
  } catch (err: any) {
    handle(err);
    dispatch(setError("Error al obtener configuración de QZ Tray."));
    showAlert("error", "Error", "No se pudo cargar la configuración de QZ Tray.");
  } finally {
    dispatch(setLoading(false));
  }
};
